"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _TimeLineCollapse = _interopRequireDefault(require("./TimeLineCollapse"));
var _TimeLineConnector = _interopRequireDefault(require("./components/TimeLineConnector"));
var _TimeLineContent = _interopRequireDefault(require("./components/TimeLineContent"));
var _TimeLineDot = _interopRequireDefault(require("./components/TimeLineDot"));
var _TimelineItem = _interopRequireDefault(require("@mui/lab/TimelineItem"));
var _TimelineSeparator = _interopRequireDefault(require("@mui/lab/TimelineSeparator"));
var _KeyboardArrowUp = _interopRequireDefault(require("@mui/icons-material/KeyboardArrowUp"));
var _KeyboardArrowDown = _interopRequireDefault(require("@mui/icons-material/KeyboardArrowDown"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "children", "isFirst", "isLast", "variant", "color", "timeLineDotComponent", "timeLineDotComponentProps", "timeLineContentProps", "withRemove", "removable", "onRemove", "fullWidth", "sx"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TimeLineItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    isFirst = _ref.isFirst,
    isLast = _ref.isLast,
    variant = _ref.variant,
    color = _ref.color,
    _ref$timeLineDotCompo = _ref.timeLineDotComponent,
    TimeLineDotComponent = _ref$timeLineDotCompo === void 0 ? _TimeLineDot["default"] : _ref$timeLineDotCompo,
    _ref$timeLineDotCompo2 = _ref.timeLineDotComponentProps,
    timeLineDotComponentProps = _ref$timeLineDotCompo2 === void 0 ? {} : _ref$timeLineDotCompo2,
    _ref$timeLineContentP = _ref.timeLineContentProps,
    timeLineContentProps = _ref$timeLineContentP === void 0 ? {} : _ref$timeLineContentP,
    withRemove = _ref.withRemove,
    removable = _ref.removable,
    onRemove = _ref.onRemove,
    fullWidth = _ref.fullWidth,
    _ref$sx = _ref.sx,
    sx = _ref$sx === void 0 ? {} : _ref$sx,
    props = _objectWithoutProperties(_ref, _excluded);
  var isCollapsable = (children === null || children === void 0 ? void 0 : children.type) === _TimeLineCollapse["default"];
  var _ref2 = (children === null || children === void 0 ? void 0 : children.props) || {},
    _ref2$initialOpen = _ref2.initialOpen,
    initialOpen = _ref2$initialOpen === void 0 ? true : _ref2$initialOpen,
    childrenSummary = _ref2.summary,
    childrenDetails = _ref2.children;
  var summary = isCollapsable ? childrenSummary : children;
  var details = isCollapsable ? childrenDetails : null;
  var withActions = withRemove || removable || isCollapsable;
  var _useState = (0, _react.useState)(initialOpen),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var handleOpen = function handleOpen() {
    setOpen(function (prev) {
      return !prev;
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_TimelineItem["default"], _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    "data-cy": 'TimeLineItem',
    sx: _objectSpread({
      minHeight: 56
    }, sx),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_TimelineSeparator["default"], {
      "data-cy": 'TimeLineSeparator',
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TimeLineConnector["default"], {
        transparent: isFirst,
        sx: {
          maxHeight: 10
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(TimeLineDotComponent, _objectSpread({
        variant: variant,
        color: color
      }, timeLineDotComponentProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimeLineConnector["default"], {
        transparent: isLast
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimeLineContent["default"], _objectSpread(_objectSpread({}, timeLineContentProps), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
        spacing: 1,
        flexGrow: fullWidth ? 1 : undefined,
        zeroMinWidth: true,
        children: [summary || withActions ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
          spacing: 1,
          direction: 'row',
          alignItems: 'center',
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
            direction: 'row',
            flex: 1,
            children: summary
          }), withActions ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack["default"], {
            spacing: 1,
            direction: 'row',
            alignItems: 'center',
            minWidth: withRemove ? 40 : null,
            children: [removable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
              icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.HighlightOffIcon, {}),
              onClick: onRemove
            }) : null, isCollapsable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
              "data-cy-action": 'toggle',
              onClick: handleOpen,
              children: open ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_KeyboardArrowUp["default"], {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_KeyboardArrowDown["default"], {})
            })]
          }) : null]
        }) : null, open ? details : null]
      })
    }))]
  }));
});
var _default = exports["default"] = TimeLineItem;